import { NgModule } from "@angular/core";
import { PrimeNgModule } from "@primeng";
import { GridModule } from "@features/grid";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { ReportingCoreModule } from "../reporting-core.module";
import { QueryPreviewComponent } from "./components/query-preview.component";


@NgModule({
    declarations: [
        QueryPreviewComponent
    ],
    exports: [
        QueryPreviewComponent
    ],
    imports: [
        GridModule,
        PrimeNgModule,
        BbwtSharedModule,
        ReportingCoreModule
    ]
})
export class QueryPreviewModule {
}